import NewBudgetItem from "../Common/NewBudgetItem";

export default function NewIncome() {
  return <NewBudgetItem itemType="income" />;
}
